import InviteVue from '@/views/member/invitation/invitation.vue';

const basePath = '/member/invitation';
const role = 'member'; // 角色身份
export const M_INVITATION_INDEX = 'm-invitation-index';

export default {
  path: `${basePath}*`,
  redirect: `${basePath}/index`,
  component: InviteVue,
  meta: { requiresAuth: true },
  children: [
    {
      path: `${basePath}/index`,
      name: M_INVITATION_INDEX,
      props: true,
      component: () => import(
        /* webpackChunkName: "reservation" */
        `@/views/${role}/invitation/index.vue`
        ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    }
  ]
};
